// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Help as HelpIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  helpButton: {
    color: theme.palette.primary.main,
  },
}));

type Props = {
  open: boolean,
  legalID: string,
  idDocumentCode: string,
  onLegalIDChange: (string) => void,
  onIdDocumentCodeChange: (string) => void,
  onConfirm: () => void,
  onCancel: () => void,
  onOpenHelp: (imageUrl: string, title: string) => void,
};

const baseUrl = process.env.PUBLIC_URL || '';

const ConfirmationDialog = (props: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    open,
    legalID,
    idDocumentCode,
    onLegalIDChange,
    onIdDocumentCodeChange,
    onConfirm,
    onCancel,
    onOpenHelp,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t('Verificación de Datos')}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: '20px', fontWeight: 500, color: '#d32f2f' }}>
          {t('ADVERTENCIA: Los datos NO PODRÁN SER MODIFICADOS una vez que la firma electrónica sea expedida. Por favor, verifique cuidadosamente que la información sea correcta antes de confirmar.')}
        </DialogContentText>
        
        <TextField
          autoFocus
          margin="dense"
          label={t('Cédula')}
          type="text"
          fullWidth
          variant="outlined"
          value={legalID}
          onChange={(e) => onLegalIDChange(e.target.value)}
          helperText={t('Ingrese el número de cédula tal como aparece en su documento')}
        />

        <TextField
          margin="dense"
          label={t('Código Dactilar')}
          type="text"
          fullWidth
          variant="outlined"
          value={idDocumentCode}
          onChange={(e) => onIdDocumentCodeChange(e.target.value)}
          helperText={t('Código dactilar ubicado en la parte posterior del documento')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  className={classes.helpButton}
                  onClick={() => onOpenHelp(`${baseUrl}/images/codigo-dactilar-reference.png`, t('¿Dónde encontrar su código dactilar?'))}
                  edge="end"
                >
                  <HelpIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="default">
          {t('Revisar datos')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t('Confirmar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
